// extracted by mini-css-extract-plugin
export var active = "nav-link-module--active--7zMIc";
export var footerLink = "nav-link-module--footer-link--nOmwy";
export var menuLink = "nav-link-module--menu-link--DRi1v";
export var notActive = "nav-link-module--not-active--0lgI1";